export const RightArrow = (props) => {
  return (
    <svg
      width="11"
      height="14"
      viewBox="0 0 11 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        class={`${props.color != undefined ? props.color : "fill-current"}`}
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.9995 7.10596L4.71875 0.825195L3.54736 1.99658L7.55078 6H0V8H7.77637L3.77344 12.0029L4.94482 13.1743L10.7734 7.3457L10.7666 7.33887L10.9995 7.10596Z"
        fill="#2B190F"
      />
    </svg>
  );
};